// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"875b1260","998":"d2d7e0c1"}[chunkId] + ".chunk.js";
};